import React from 'react';
import { Field } from '@h2/types';

interface CheckboxInputProps {
  field: Field;
  value: boolean;
  onChange: (value: boolean) => void;
  error?: string;
}

export const CheckboxInput: React.FC<CheckboxInputProps> = ({ field, value, onChange, error }) => {
  return (
    <div className="flex items-center space-x-2">
      <input
        id={field.id}
        type="checkbox"
        checked={value || false}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
      />
      <label htmlFor={field.id} className="text-sm text-gray-700">
        {field.placeholder || '동의합니다'}
      </label>
    </div>
  );
};
